export var DEFAULT_IMAGE = {
  USER_PROFILE: 'assets/img/default-image/user_profile.jpg',
  DEFAULT_SUBSCRIPTION: 'assets/img/offer.png',
  DEFAULT_PRODUCT: 'assets/img/default-image/default_menu_img.jpg',
  DEFAULT_LOGO :'assets/img/default-image/Logo_header.png'
};

export const TOAST_STATE = {
  success: 'success-toast',
  warning: 'warning-toast',
  danger: 'danger-toast',
};

export const STRIPE_IMAGE = {
  default: 'assets/img/card-image/default.png',
  visa: 'assets/img/card-svg/Light Color/1.png',
  mastercard: 'assets/img/card-svg/Light Color/2.png',
  amex: 'assets/img/card-svg/Light Color/22.png',
  discover: 'assets/img/card-svg/Light Color/14.png',
  diners: 'assets/img/card-svg/Light Color/10.png',
  jcb: 'assets/img/card-svg/Light Color/16.png',
  unionpay: 'assets/img/card-svg/Light Color/union-pay.png',
};

export const FORM_VALIDTIONS = {
  pattern : '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$',
  password_length : 6,
  number_length: 1
}

export const EnitityType = {
  admin: 1,
  user: 2
}

export enum StringType {
  MESSAGE_CODE_STRINGS = 1,
  WEBSITE_STRINGS = 3,
  PANEL_STRINGS = 2,
}